<script lang="ts">
import { useMMStore } from '@/store/MarvelMachine'
const mmStore = useMMStore()
export default function useMarvelBreakPoint() {
  const mobileSize = 900
  const tabletSize = 1124
  let isMobile = false
  let isTablet = false
  let isDesktop = false

  const checkBreakpoint = () => {
    isMobile = window.innerWidth <= mobileSize
    isTablet = window.innerWidth > mobileSize && window.innerWidth <= tabletSize
    isDesktop = window.innerWidth > tabletSize
    mmStore.breakpoint = {
      isMobile,
      isTablet,
      isDesktop,
    }
  }
  const init = () => {
    checkBreakpoint()
    // Attach event listener to window resize
    window.addEventListener('resize', checkBreakpoint, { passive: true })
  }
  const uninit = () => {
    window.removeEventListener('resize', checkBreakpoint)
  }
  return {
    init,
    uninit,
  }
}
</script>
